import React, { useEffect } from 'react'
import { Modal, Form, Input, InputNumber, message } from 'antd'
import { useDangerModel } from '../dangerModel'

export const EditDangerModal: React.FC = () => {
    const [form] = Form.useForm()
    const { editModalVisible, editFormData, setEditModalVisible, setEditFormData, loadData, updateAmount } = useDangerModel()

    useEffect(() => {
        if (editModalVisible && editFormData) {
            form.setFieldsValue({
                id: editFormData.id,
                amount: editFormData.amount,
                inspectionCost: editFormData.inspectionCost,
            })
        }
    }, [editModalVisible, editFormData, form])

    const handleOk = async () => {
        try {
            const values = await form.validateFields()
            const result = await updateAmount({
                id: editFormData.id as string,
                amount: values.amount,
                inspectionCost: values.inspectionCost,
            })

            if (result.success) {
                message.success(result.message)
                handleCancel()
                loadData()
            } else {
                message.error(result.message)
            }
        } catch (error) {
            console.error('表单验证失败:', error)
        }
    }

    const handleCancel = () => {
        setEditModalVisible(false)
        setEditFormData({})
        form.resetFields()
    }

    return (
        <Modal title="编辑隐患" open={editModalVisible} onOk={handleOk} onCancel={handleCancel} okText="保存" cancelText="取消" width={600}>
            <Form
                form={form}
                layout="vertical"
                initialValues={{
                    id: editFormData?.id,
                    amount: editFormData?.amount,
                    inspectionCost: editFormData?.inspectionCost,
                }}
            >
                <Form.Item
                    name="amount"
                    label="金额"
                    rules={[
                        { required: true, message: '请输入金额' },
                        { type: 'number', min: 0, message: '金额必须大于等于0' },
                    ]}
                >
                    <InputNumber style={{ width: '100%' }} placeholder="请输入金额" min={0} step={0.01} precision={2} />
                </Form.Item>

                <Form.Item name="inspectionCost" label="备注" rules={[{ required: true, message: '请输入备注' }]}>
                    <Input.TextArea rows={3} placeholder="请输入备注" maxLength={200} showCount />
                </Form.Item>
            </Form>
        </Modal>
    )
}
